import { REVISION_DATE_2021_04 } from "@constants/variables";

export const checkAfterOrEqualTo202104 = (date: Date): boolean => {
  return REVISION_DATE_2021_04 <= date;
};
